import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { CreatePlaceCommand } from '../../../commands/hub/place/create.place.command';
import { BaseComponent } from '../../../common/components/base.component';
import { SuccessWrapComponent } from '../../../common/components/success.wrap/success.wrap.component';
import { ModalService } from '../../../common/services/modal.service';
import { HubVisitorFeatureToggle } from '../../../models/hub/hub.visitor.feature.toggle';
import { ImageService } from '../../../services/image.service';
import { VisitorApiService } from '../../../services/visitor.api.service';
import { HubApiService } from '../../../services/hub.api.service';
import { AllFrontendSettingsCommand } from '../../../commands/visitor/all.frontend.settings.command';
import { localStorageKeys } from '../../../common/constants/local.storage.keys';
import { PlaceType } from '../../hub/place.category/customize.place.category.component';
import { AllFrontendSettingsStore, VisitorCalendarStore } from '../../../stores/visitor.calendar.store';
import { CustomPlaceCommand } from '../../../commands/hub/custom.event.command';
import { EditorChoiceDataSource } from '../../../models/hub/hub.event';
import { EditorChoiceStore } from '../../../stores/hub.calendar.store';
import { getRouteUrl, routeConfigs } from '../../../common/constants/route.config';
import { VisitorCalendarActionCommand } from '../../../commands/pagination.query.command';
import { AccordionComponent } from '../../../common/components/accordion/accordion.component';
import { PlaceCategory } from '../../../common/constants/constant';
import { VisitorPlaceMapComponent } from '../place.map/visitor.place.map.component';

@Component({
    selector: 'ig-custom-place-btn',
    templateUrl: './custom.place.btn.component.html',
    styleUrls: ['./custom.place.btn.component.scss'],
})
export class CustomPlaceBtnComponent extends BaseComponent implements OnInit {
    public hubName: string;
    public isHideEditorChoice = false;
    public editorChoiceText = "EDITOR'S CHOICE";
    public command = new VisitorCalendarActionCommand();
    public customPlaces: CustomPlaceCommand[] = [];
    public selectedCustomPlace: CustomPlaceCommand = null;
    @Input() public mode: 'topbar' | 'sidebar' = 'topbar';
    @ViewChild('description') public descriptionArea: ElementRef;
    @ViewChild('customPlaceAccordion') public customPlaceAccordion: AccordionComponent;
    @Output() onCustomPlaceSelected: EventEmitter<any> = new EventEmitter<VisitorCalendarActionCommand>();

    constructor(
        private formBuilder: FormBuilder,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private allFrontendSettingsStore: AllFrontendSettingsStore,
        private editorChoiceStore: EditorChoiceStore,
        private visitorCalendarStore: VisitorCalendarStore
    ) {
        super({ activatedRoute });
    }

    public ngOnInit() {
        let { hubName, customPlaceBtnId } = this.allRouteParams;
        this.hubName = hubName;

        this.allFrontendSettingsStore.allFrontendSettingsCommand
            .takeUntil(this.isDestroyed)
            .subscribe((command: AllFrontendSettingsCommand) => {
                if (command.customSettings) {
                    this.isHideEditorChoice = command.customSettings.isHideEditorChoice || false;
                    this.customPlaces = command.customSettings.customPlaces || null;

                    // if this is a custom place btn URL, set the selection status
                    if (customPlaceBtnId) {
                        const customBtnInUrl = this.customPlaces.find((x) => x._id === customPlaceBtnId);
                        console.log('customBtnInUrl', customBtnInUrl);
                        if (customBtnInUrl) {
                            setTimeout(() => {
                                this.createCustomBtnCommand(customBtnInUrl);
                            });
                        }
                    }
                }
            });

        this.editorChoiceTextHandler();
        this.command.isMapView = this.activatedRoute.component === VisitorPlaceMapComponent;
    }

    public editorChoiceTextHandler() {
        this.editorChoiceStore.infoCommand
            .takeUntil(this.isDestroyed)
            .subscribe((editorChoice: EditorChoiceDataSource) => {
                this.editorChoiceText = editorChoice.editorChoiceForPlace || "EDITOR'S CHOICE";
            });
    }

    public clearFilter() {
        this.customPlaceAccordion && this.customPlaceAccordion.clearFilter(null, false);
        this.selectedCustomPlace = null;
        // localStorage.removeItem(localStorageKeys.selectedPlaceCategory);
    }

    public setFilter(title: string, isEditorChoice = false) {
        this.customPlaceAccordion && this.customPlaceAccordion.setFilter(title);
        this.selectedCustomPlace = this.customPlaces.find((x) => x.btnText === title);
        console.log('selectedCustomPlace', this.selectedCustomPlace);
        isEditorChoice && (this.command.queryCommand.choice = true);
    }

    public close() {
        this.customPlaceAccordion && this.customPlaceAccordion.close();
    }

    public editChoice() {
        this.command.queryCommand.search = null;
        this.command.queryCommand.category = null;
        this.command.queryCommand.choice = true;
        this.command.queryCommand.isCustom = null;
        this.command.isEventCalendar = false;
        this.command.queryCommand.selectedPlaces = null;
        this.command.queryCommand.customPlaceBtnText = this.editorChoiceText;
        this.selectedCustomPlace = null;

        localStorage.setItem(localStorageKeys.selectedPlaceCategory, JSON.stringify(this.command));

        this.visitorCalendarStore.actionCommand.next(this.command);
        // visitor.components.ts uses this to handle browser's back button event
        this.customPlaceAccordion && this.customPlaceAccordion.setFilter(this.editorChoiceText);
        this.mode === 'topbar' && this.customPlaceAccordion && this.customPlaceAccordion.close();
        this.onCustomPlaceSelected.emit(this.command);
    }

    public getFeedPlace(custom: CustomPlaceCommand) {
        this.createCustomBtnCommand(custom);
        this.visitorCalendarStore.actionCommand.next(this.command);

        if (!this.command.isMapView) {
            this.router.navigateByUrl(
                // getRouteUrl(routeConfigs.visitor.placeCalendar, {
                //     hubName: this.hubName,
                //     category: 'all',
                // }),
                getRouteUrl(routeConfigs.visitor.customPlace, {
                    hubName: this.hubName,
                    customPlaceBtnId: custom._id,
                }),
                { skipLocationChange: this.noChangeUrlWhenRedirect }
            );
        }

        this.mode === 'topbar' && this.customPlaceAccordion && this.customPlaceAccordion.close();
        this.onCustomPlaceSelected.emit(custom);
    }

    public all() {
        localStorage.removeItem(localStorageKeys.selectedPlaceCategory);

        this.command.isEventCalendar = false;
        this.command.queryCommand.choice = false;
        this.command.queryCommand.search = null;
        this.command.queryCommand.isCustom = null;
        this.command.isEventCalendar = false;
        this.selectedCustomPlace = null;
        this.command.queryCommand.category = 'All';
        if (!this.command.isMapView) {
            this.router.navigateByUrl(
                getRouteUrl(routeConfigs.visitor.placeCalendar, {
                    hubName: this.hubName,
                    category: this.command.queryCommand.category,
                }),
                { skipLocationChange: this.noChangeUrlWhenRedirect }
            );
        }
        this.visitorCalendarStore.actionCommand.next(this.command);
        this.customPlaceAccordion && this.customPlaceAccordion.clearFilter(null, false);
        this.mode === 'topbar' && this.customPlaceAccordion && this.customPlaceAccordion.close();
        this.onCustomPlaceSelected.emit(this.command);
    }

    private createCustomBtnCommand(custom: CustomPlaceCommand) {
        this.command.queryCommand.choice = false;
        this.command.queryCommand.search = null;
        this.command.queryCommand.category = null;
        this.command.queryCommand.isCustom = true;
        this.command.queryCommand.categoryList = null;
        this.command.queryCommand.type = custom._id;
        this.command.isEventCalendar = false;
        this.command.queryCommand.selectedPlaces = undefined;
        this.command.queryCommand.customPlaceBtnText = custom.btnText;

        localStorage.setItem(localStorageKeys.selectedPlaceCategory, JSON.stringify(this.command));
        this.selectedCustomPlace = custom;
        this.customPlaceAccordion && this.customPlaceAccordion.setFilter(custom.btnText);
    }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/custom.place.btn/custom.place.btn.component.ts